import { render, staticRenderFns } from "./drawings.vue?vue&type=template&id=1f78bb55&scoped=true"
import script from "./drawings.vue?vue&type=script&lang=js"
export * from "./drawings.vue?vue&type=script&lang=js"
import style0 from "./drawings.vue?vue&type=style&index=0&id=1f78bb55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f78bb55",
  null
  
)

export default component.exports